import * as React from 'react'
import { Typography, IconButton, Chip } from '@mui/material'
import { styled } from '@mui/material/styles'
import ChipDeleteIcon from '$common/icons/chip-delete'

const StyledChip = styled(Chip)(({ theme }) => ({
  padding: 4,
  backgroundColor: theme.palette.veryLightGray,

  '.MuiChip-avatar': {
    margin: 0,
  },
  '.MuiChip-label': {
    margin: '0 5px',
    padding: 0,
  },
  '.MuiChip-deleteIcon': {
    margin: 0,
  },

  marginLeft: 6,
  marginRight: 0,

  '&:first-of-type': {
    marginRight: 15,
  },
  '&:last-child': {
    marginLeft: 15,
  },
}))

const StyledIconButton = styled(IconButton)`
  width: 20px;
  height: 20px;

  background-color: #9b9c9c;

  &:hover {
    background-color: #737373;
  }
`

interface Props {
  firstname: string
  lastname: string
  onDelete: (id: string) => void
}

export function InviteeChip({ firstname, lastname, onDelete }: Props) {
  const label = [firstname, lastname].filter(Boolean).join(' ')

  return (
    <StyledChip
      label={
        <Typography color="semiBlack" variant="caption1">
          {label}
        </Typography>
      }
      deleteIcon={
        <StyledIconButton>
          <ChipDeleteIcon sx={{ color: '#fff', fontSize: '8px' }} />
        </StyledIconButton>
      }
      onDelete={onDelete}
    />
  )
}
